import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"

import { hasLength, isEmail, useForm } from "@mantine/form"
import { AuthError, signInWithEmailAndPassword } from "firebase/auth"

import { firebase } from "../../../../services/firebase/firebase"
import { useAuth } from "../../../../contexts/authentication-context"
import { useLanguage } from "../../../../contexts/language-context"

export default () => {
    const [loading, setLoading] = useState(false)
    const { isAuth } = useAuth()
    const navigate = useNavigate()
    const { L } = useLanguage()
    const form = useForm({
        initialValues: { email: "", password: "" },
        validate: {
            email: isEmail(L("Must be a valid email address")),
            password: hasLength({ min: 6 }, L("Must be at least %s characters long", 6)),
        },
    })

    const signInWithPassword = (values: typeof form.values) => {
        setLoading(true)
        signInWithEmailAndPassword(firebase.auth, values.email, values.password)
            .catch((error: AuthError) => {
                if (error.code === "auth/user-not-found")
                    form.setFieldError("email", L("No user with that email address exists"))
                else if (error.code === "auth/wrong-password") form.setFieldError("password", L("Incorrect password"))
            })
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        if (isAuth) navigate("/")
    }, [isAuth, navigate])

    return { form, signInWithPassword, loading }
}
